var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.367 9.93194L9.42577 7.51052C9.83618 6.78546 10.0824 5.93727 10.0824 5.03437C10.0824 2.25726 7.81148 0 5.03437 0C2.25726 0 0 2.25726 0 5.03437C0 7.81148 2.25726 10.0824 5.03437 10.0824C5.93727 10.0824 6.77178 9.84986 7.51052 9.42577L9.93194 12.367C10.5886 13.1605 11.7651 13.2152 12.4902 12.4902C13.2152 11.7651 13.1605 10.5749 12.367 9.93194ZM1.50484 5.03437C1.50484 3.09176 3.09176 1.50484 5.03437 1.50484C6.97698 1.50484 8.5639 3.09176 8.5639 5.03437C8.5639 6.97698 6.97698 8.5639 5.03437 8.5639C3.09176 8.5639 1.50484 6.99066 1.50484 5.03437Z",
    fill: "#0C4BBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.fc301140f55dc0d4cfb682bf450a00dd.svg";
export { ForwardRef as ReactComponent };